webpackJsonp([275037778433214],{

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _marked = __webpack_require__(11);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FAQ = function FAQ(props) {
	    return _react2.default.createElement(
	        _Row2.default,
	        { className: 'block-faq', id: props.id },
	        _react2.default.createElement(
	            _Column2.default,
	            { width: '8', offsetL: '4', tablet: '12' },
	            props.title && _react2.default.createElement(
	                'h2',
	                { className: 'h2' },
	                props.title
	            ),
	            props.questions && props.questions.map(function (q, k) {
	                return _react2.default.createElement(
	                    'span',
	                    { key: q.id },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'h3' },
	                        q.question
	                    ),
	                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(q.answer.internal.content) } })
	                );
	            })
	        )
	    );
	};
	
	exports.default = FAQ;
	module.exports = exports['default'];

/***/ }),

/***/ 749:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Network":"src-components-WhatAboutCollege-Network----Network-module---Network---9a7w5","Network__Wrapper":"src-components-WhatAboutCollege-Network----Network-module---Network__Wrapper---2kD44","Logos":"src-components-WhatAboutCollege-Network----Network-module---Logos---3eNph","Logo":"src-components-WhatAboutCollege-Network----Network-module---Logo---ZkVVJ"};

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NetworkModule = __webpack_require__(749);
	
	var _NetworkModule2 = _interopRequireDefault(_NetworkModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Network = function Network(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _NetworkModule2.default.Network, id: props.id },
	    _react2.default.createElement(
	      'div',
	      { className: _NetworkModule2.default.Network__Wrapper },
	      _react2.default.createElement(
	        'h2',
	        { className: 'h2' },
	        props.title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        props.text
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _NetworkModule2.default.Logos + ' logos' },
	        props.logos.map(function (logo, i) {
	          return _react2.default.createElement(
	            'a',
	            { key: i, href: logo.link.link, title: logo.link.text, className: 'partner-logo-link', target: '_blank' },
	            _react2.default.createElement('img', { src: logo.logo.file.url, alt: logo.logo.title, className: _NetworkModule2.default.Logo })
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = Network;
	module.exports = exports['default'];

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Story":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---Story---1-EGp","StoryItemTwo":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---StoryItemTwo---Fuyb8","StoryItemTwo__Left":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---StoryItemTwo__Left---24KWj","StoryItemTwo__Right":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---StoryItemTwo__Right---30XFC","Strokes":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---Strokes---32pt9","Strokes__Yellow":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---Strokes__Yellow---N8NVj","Strokes__Blue":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---Strokes__Blue---1rR89"};

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VimeoEmbed = __webpack_require__(117);
	
	var _VimeoEmbed2 = _interopRequireDefault(_VimeoEmbed);
	
	var _TestimonialsModule = __webpack_require__(378);
	
	var _TestimonialsModule2 = _interopRequireDefault(_TestimonialsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Testimonial = function Testimonial(props) {
	  return _react2.default.createElement(
	    'div',
	    { id: props.id, className: _TestimonialsModule2.default.Story, style: props.style },
	    _react2.default.createElement(
	      'div',
	      { className: _TestimonialsModule2.default.Story__Wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _TestimonialsModule2.default.StoryItem + ' ' + _TestimonialsModule2.default.StoryItemTwo },
	        _react2.default.createElement(
	          'div',
	          { className: _TestimonialsModule2.default.StoryItemTwo__Left },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { className: 'profile-image', src: props.testimonials.profileImage.file.url, alt: props.testimonials.profileImage.title }),
	            _react2.default.createElement('h3', { dangerouslySetInnerHTML: { __html: props.testimonials.title } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _TestimonialsModule2.default.StoryItemTwo__Right },
	          _react2.default.createElement(
	            'p',
	            { className: 'animated' },
	            props.testimonials.quote
	          ),
	          props.testimonials.videoLink && _react2.default.createElement(_VimeoEmbed2.default, {
	            url: props.testimonials.videoLink,
	            poster: props.testimonials.videoPosterImage ? props.testimonials.videoPosterImage : '',
	            loop: false,
	            autoplay: false,
	            controls: true
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Testimonial;
	module.exports = exports['default'];

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _marked = __webpack_require__(11);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Apply = __webpack_require__(20);
	
	var _Apply2 = _interopRequireDefault(_Apply);
	
	var _Afterhero = __webpack_require__(292);
	
	var _Afterhero2 = _interopRequireDefault(_Afterhero);
	
	var _Hero = __webpack_require__(293);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Network = __webpack_require__(551);
	
	var _Network2 = _interopRequireDefault(_Network);
	
	var _DINavigation = __webpack_require__(69);
	
	var _DINavigation2 = _interopRequireDefault(_DINavigation);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _BannerImage = __webpack_require__(63);
	
	var _BannerImage2 = _interopRequireDefault(_BannerImage);
	
	var _FAQ = __webpack_require__(550);
	
	var _FAQ2 = _interopRequireDefault(_FAQ);
	
	var _QuotesWithImages = __webpack_require__(157);
	
	var _QuotesWithImages2 = _interopRequireDefault(_QuotesWithImages);
	
	var _Testimonial = __webpack_require__(345);
	
	var _Testimonial2 = _interopRequireDefault(_Testimonial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollMagic;
	if (typeof window === 'object') {
	  ScrollMagic = __webpack_require__(24);
	}
	
	// if(typeof window == 'object') {
	// 	require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js')
	// }
	
	var WhatAbout = function (_React$Component) {
	  _inherits(WhatAbout, _React$Component);
	
	  function WhatAbout(props) {
	    _classCallCheck(this, WhatAbout);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      activeNav: '',
	      controller: null
	    };
	    _this.links = [{ name: 'College Opinions', reference: 'opinions' }, { name: 'How to Defer', reference: 'defer' }, { name: 'College Partnerships', reference: 'college-network' }];
	    return _this;
	  }
	
	  WhatAbout.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var opinions = document.querySelector('#opinions'),
	        defer = document.querySelector('#defer'),
	        collegeNetwork = document.querySelector('#college-network'),
	        offset = 420;
	    this.controller = new ScrollMagic.Controller();
	    this.setState({
	      controller: this.controller
	    });
	    setTimeout(function () {
	      return _this2.navSceneInit();
	    }, 450);
	    // this.navSceneInit()
	    window.addEventListener('scroll', function () {
	      var opinionsTrigger = opinions.offsetTop - offset,
	          deferTrigger = defer.offsetTop - offset,
	          collegeNetworkTrigger = collegeNetwork.offsetTop - offset;
	
	      console.log('SCROLL ===', opinionsTrigger);
	      var doc = document.documentElement,
	          top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
	
	      if (top > collegeNetworkTrigger) {
	        _this2.state.activeNav != 'college-network' ? _this2.setState({ activeNav: 'college-network' }) : null;
	      } else if (top > deferTrigger) {
	        _this2.state.activeNav != 'defer' ? _this2.setState({ activeNav: 'defer' }) : null;
	      } else if (top > opinionsTrigger) {
	        _this2.state.activeNav != 'opinions' ? _this2.setState({ activeNav: 'opinions' }) : null;
	      } else {
	        _this2.state.activeNav != '' ? _this2.setState({ activeNav: '' }) : null;
	      }
	    });
	  };
	
	  WhatAbout.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.state.controller.destroy(true);
	    this.controller.destroy(true);
	  };
	
	  WhatAbout.prototype.navSceneInit = function navSceneInit() {
	    var triggerHook = window.innerWidth > 1200 ? .3 - 207 / window.innerHeight : 65 / window.innerHeight;
	    this.navScene = new ScrollMagic.Scene({
	      triggerElement: this.refs.pageNav,
	      triggerHook: triggerHook
	    }).setPin(this.refs.pageNav.children[0]).addTo(this.controller);
	    // .addIndicators()
	  };
	
	  WhatAbout.prototype.render = function render() {
	    var _this3 = this,
	        _React$createElement;
	
	    var _props$data = this.props.data,
	        page = _props$data.page,
	        home = _props$data.home;
	
	    var seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : '';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'program' },
	      _react2.default.createElement(_CustomHelmet2.default, { data: page.seoData }),
	      _react2.default.createElement(_Hero2.default, {
	        title: page.title,
	        image: page.heroImage,
	        style: { zIndex: '2' }
	      }),
	      _react2.default.createElement(
	        'div',
	        { id: 'DIPageNav', ref: 'pageNav' },
	        _react2.default.createElement(_DINavigation2.default, {
	          activeNav: this.state.activeNav,
	          callbackRef: function callbackRef(el) {
	            return _this3.pagenav = el;
	          },
	          links: this.links
	        })
	      ),
	      _react2.default.createElement(_Afterhero2.default, {
	        text: page.heroSplashText.internal.content
	      }),
	      _react2.default.createElement(_QuotesWithImages2.default, {
	        id: 'opinions',
	        items: page.collegeOpinions
	      }),
	      _react2.default.createElement(_Testimonial2.default, {
	        testimonials: page.testimonial
	      }),
	      _react2.default.createElement(_FAQ2.default, {
	        id: 'defer',
	        title: page.faqTitle,
	        questions: page.faq
	      }),
	      _react2.default.createElement(_Network2.default, {
	        id: 'college-network',
	        title: page.partnersSectionTitle,
	        text: page.partnersSectionContent.internal.content,
	        logos: page.partnerLogos
	      }),
	      _react2.default.createElement(
	        _Row2.default,
	        { id: 'colleges-w-gap-years' },
	        _react2.default.createElement(
	          _Column2.default,
	          { width: '8', offsetL: '4', tablet: '12' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'h2', style: { marginBottom: '20px' } },
	            page.collegesWithGapYearsTitle
	          ),
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(page.collegesWithGapYearsContent.internal.content) } })
	        )
	      ),
	      _react2.default.createElement(
	        _Row2.default,
	        { style: { zIndex: '10' }, className: 'bg-grey' },
	        _react2.default.createElement(
	          _Column2.default,
	          (_React$createElement = { width: '10', tablet: '12' }, _React$createElement['tablet'] = '12', _React$createElement.style = { maxWidth: '1040px', margin: '0 auto 0 auto' }, _React$createElement),
	          _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(page.disclaimer.disclaimer) } })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section', style: { zIndex: '10', position: 'relative' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'banner-wrap' },
	          _react2.default.createElement(_BannerImage2.default, { image: page.bannerImage })
	        )
	      ),
	      _react2.default.createElement(_Apply2.default, {
	        title: page.applyTitle,
	        buttonText: 'Request Info',
	        buttonUrl: '/#signup'
	      })
	    );
	  };
	
	  return WhatAbout;
	}(_react2.default.Component);
	
	exports.default = WhatAbout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-what-about-college-js-6610ce0ba9dc85613ca2.js